module.exports = {"default":["\\","`","*","{","}","[","]","(",")","#","+","-",".","!","_",">"],"gfm":["\\","`","*","{","}","[","]","(",")","#","+","-",".","!","_",">","~","|"],"commonmark":["\\","`","*","{","}","[","]","(",")","#","+","-",".","!","_",">","~","|","\n","\"","$","%","&","'",",","/",":",";","<","=","?","@","^"]}


//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/escapes.json
// module id = 650
// module chunks = 168707334958949